import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

const PopPanel = resolve => require(['@/components/layout/PopPanel'], resolve)
const ColumnTwo = resolve => require(['@/components/layout/ColumnTwo'], resolve)
const UserAuthLogin = resolve => require(['@/components/userAuth/Login'], resolve)
const MerchantUserList = resolve => require(['@/components/merchantUser/List'], resolve)
const MerchantUserCreate = resolve => require(['@/components/merchantUser/Create'], resolve)
const MerchantUserUpdate = resolve => require(['@/components/merchantUser/Update'], resolve)
const MerchantUserUpdatePasswd = resolve => require(['@/components/merchantUser/UpdateLoginPasswd'], resolve)
// 取号订单
const QueueOrderList = resolve => require(['@/components/QueueOrder/list'], resolve)
// 订单统计
const QueueOrderListStatistics = resolve => require(['@/components/QueueOrder/listStatistics'], resolve)
// 商户中心merchantInfo
const MerchantInfoCreate = resolve => require(['@/components/merchantInfo/Create'], resolve)

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: {name: 'home'}
    },
    {
      path: '/userAuth',
      component: PopPanel,
      children: [
        {name: 'userAuthLogin', path: 'login', component: UserAuthLogin},
        {name: 'officialAccounts', path: 'officialAccounts', component: () => import('@/components/layout/officialAccounts')}
      ]
    },
    {
      path: '/',
      component: ColumnTwo,
      children: [
        {name: 'home', path: 'home', component: HelloWorld},
        {name: 'merchantUserList', path: 'merchantUser/list.do', component: MerchantUserList},
        {name: 'merchantUserCreate', path: 'merchantUser/create.do', component: MerchantUserCreate},
        {name: 'merchantInfoCreate', path: 'merchantInfo/create.do', component: MerchantInfoCreate},
        {name: 'merchantUserUpdatePasswd', path: 'merchantUser/updatePasswd.do', component: MerchantUserUpdatePasswd},
        {name: 'merchantUserUpdate', path: 'merchantUser/update.do/:userId', component: MerchantUserUpdate},
        {name: 'queueOrderList', path: 'queueOrder/listMerchant.do', component: QueueOrderList},
        {name: 'queueOrderListStatistics', path: 'queueOrder/queueStatisticsByMerchant.do', component: QueueOrderListStatistics}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js